/**
 *    @author:
 *    @since:
 *
 */

import { IValidator } from '../_common/component/IValidator';
import { SINMainComponent} from './SIN_main.component';
import { ViewportScroller } from '@angular/common';
import { Confirm } from 'src/refresh/service/constant';
import { SIN } from '../_common/data/input-data';

const PREFIX = "SIN_main.error.";

export class SINMainValidation extends IValidator {

       constructor(private component: SINMainComponent,
                   private viewportScroller: ViewportScroller, private menuID:number ) {  
                         super(); 
                         this.SIN.backup( this.component.data );
       }

       private SIN:SIN = new SIN();

       private success: boolean;

       public validate(): boolean {

            this.success = true;
 
            if ( this.component.parentCount > 2) {  
                  let chk = this.chk()
                   if(chk != 2){
                        this.focus("parents","chkbox_parentsCheckbox0").error_chkParents = PREFIX + 'indicate_chk';
                   } 
            } 

            if( this.component.sin.chk_read == false ){
                  if(this.component.parentCount == 1){
                        this.focus("read","chkbox_readCheckbox").error_chkRead = PREFIX + 'notive_chk_1';
                  } else {
                        this.focus("read","chkbox_readCheckbox").error_chkRead = PREFIX + 'notive_chk_2';
                  }
            }
 
            if( this.component.sin.chk_certify != Confirm.YES ){    
                  this.focus("certify","chkbox_certifyCheckbox").error_chkCertify = PREFIX + 'certify_chk';
            }

            return this.success;

       }

       public checkParents(): boolean{
            if ( this.component.parentCount > 2) {  
                  let chk = this.chk();
                   if(chk > 2){
                        this.noticeError();
                   } 
            } 
            return !this.component.error_chkParents;
       }

       public chk(){
            let chk = 0;
                  for ( let i = 0; i < this.component.parentCount; i++ ) {
                        if(this.component.data.parentList[i].isSINParent ){
                              chk++;
                        }
                   }
           return chk;
       }

       public noticeError(){
            return this.component.error_chkParents = PREFIX + 'indicate_chk';
       }

       private jump(tagId:string) : SINMainComponent {
            if ( this.success )
                 this.viewportScroller.scrollToAnchor(tagId);
            this.success = false;
            return this.component;
       }

       private focus(tagId:string,ctrlId:string) : SINMainComponent {
            if ( this.success ) {
                 this.viewportScroller.scrollToAnchor(tagId);
                 let ctrl = document.getElementById(ctrlId);
                 if ( ctrl ) ctrl.focus();
            }
                 
            this.success = false;
            return this.component;
       }

       public IdOfChanged():number { 
            let inputSIN:SIN = this.component.data.SIN;
            if ( this.SIN.chk_read != inputSIN.chk_read 
              || this.SIN.chk_certify != inputSIN.chk_certify 
               ) return this.menuID;

            for ( let i = 0; i < this.component.data.eligibility.listedParentCount; i++ ) {
                  ////console.log("#"+i,this.SIN.bkSINParent[i],this.component.data.parents[i].isSINParent);
                  if ( this.SIN.bkSINParent[i] != this.component.data.parents[i].isSINParent ) return this.menuID;
            }

            return 0;
       }

}

